/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 37,
  image: "default-changelog-v2.png",
  title: "Fiat Integration, Introducing Jupyter Notebook to Spheron Marketplace & Platform Improvements & Fixes",
  shortDescription: "Platform improvements include resolving issues with notification toast, compute dashboard, loaders, and introducing Jupyter Notebook to the marketplace, along with fiat integration for convenient credit card payments and enhanced user experience in payment history, invoices, and web3 wallet attachment.",
  description: "Platform improvements include resolving issues with notification toast, compute dashboard, loaders, and introducing Jupyter Notebook to the marketplace, along with fiat integration for convenient credit card payments and enhanced user experience in payment history, invoices, and web3 wallet attachment.",
  date: "July 10th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Jupyter", "Credit card", "fiat", "payment", "method", "stripe", "marketplace", "notification", "compute"]
};
export const content = `

## Fiat Integration

We are excited to introduce the integration of Stripe, enabling fiat payment for subscriptions and bonuses. This integration makes paying with your credit card more convenient than ever before.

Additionally, we have enhanced the payment process by introducing the ability to add multiple payment methods. You now have the flexibility to choose from various credit cards and web3 wallets. Furthermore, you can designate a primary payment method with backup options. The system will prioritize the primary method for payment and automatically select an alternative if the primary method has insufficient funds.

To improve the user experience, we have made enhancements to the payment history and invoice user interface. Checking your organization's payments is now more intuitive, and you can easily print receipts directly from the invoices. We have also consolidated deposit and withdrawal information on the payment history page for convenient reference.

Furthermore, we have updated the web3 wallet attachment modal to be more compact, saving screen space. Along with this update, we have simplified the pay overdue interface, making it effortless for users to settle any outstanding payments.

## Introducing Jupyter Notebook to Spheron Marketplace

<div className="image-box-shadow">
  <img
    src="/changelog/2023-07-10/jupyter.png"
    alt="jupyter-notebook"
    className="rounded-[12px]"
  />
</div>

We are excited to announce the latest addition to our marketplace: [Jupyter Notebook](https://app.spheron.network/#/compute/marketplace?template=Jupyter%20Notebook). This new feature empowers data scientists and ML engineers by providing them with the ability to effortlessly spin up their own Jupyter Notebook instances, enabling them to build and develop their machine learning models efficiently.

By offering Jupyter Notebook in our marketplace, we aim to streamline the workflow of machine learning practitioners, providing them with a dedicated workspace to analyze data, prototype algorithms, and collaborate on projects. Whether it's data exploration, feature engineering, model training, or model evaluation, Jupyter Notebook serves as a flexible and interactive platform to bring ideas to life.

With Jupyter Notebook now readily available on our marketplace, we are thrilled to provide data scientists and ML engineers with a seamless and efficient environment to unleash their creativity, drive innovation, and accelerate their machine learning projects. Start exploring the possibilities today and take your ML journey to new heights.

## Platform Improvements & Fixes

- **Notification Toast:** Resolved the issue where the notification toast was triggered multiple times, ensuring a smoother user experience.

- **Compute Dashboard:** Fixed the intermittent problem of web-app projects being called in the compute dashboard, providing consistent and accurate results.

- **Loaders:** Several loaders on the billing page have been fixed, ensuring they display the appropriate information without any glitches or delays.

- **Coupon:** We have addressed the issue where the monthly total was not correctly set to $0 when a valid coupon was applied.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
